import React from 'react';
import ReactDOM from 'react-dom';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import '../sass/app.scss';
import registerServiceWorker from './registerServiceWorker';
import Booking from './Booking';
import ReservationForm from './ReservationForm';

const bookingEl = document.getElementById('root')
const reservationsEl = document.getElementById('reservations')

bookingEl && ReactDOM.render(<Booking />, bookingEl);
reservationsEl && ReactDOM.render(<ReservationForm />, reservationsEl);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/js/index.js